import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'

// TODO: Need to make READ notifications appear differently, perhaps reinsert icon
class NotificationsMenu extends Component {
  constructor() {
    super()
    this.state = {
      notifications: [],
      unreadCount: 0,
      is_loading: true,
    }
    this.renderNotificationListItem = this.renderNotificationListItem.bind(this)
    this.dismissNotification = this.dismissNotification.bind(this)
  }

  componentDidMount() {
    this.getNotifications()
  }

  getNotifications() {
    const READ = 1
    axios.get('/notifications/get_notifications').then(({ data }) => {
      this.setState({
        notifications: data.notifications.map((x) => {
          if (x.url) {
            x.url = x.url.replace('user/user_reports', 'user/profile#reports')
          }
          x.read = x.read == READ
          x.hide_record = Boolean(Number(x.hide_record))
          return x
        }),
        unreadCount: data.unread,
        is_loading: false,
      })
    })
  }

  renderNotificationButtonContent() {
    const unreadCount = this.state.unreadCount
    return (
      <div>
        <i className="fa fa-fw fa-flag fa-fw hidden-sm hidden-xs" />{' '}
        {this.state.is_loading && (
          <span className="ball-scale">
            <div style={{ margin: '-0.25em 0.5em', height: '16px', width: '16px' }} />
          </span>
        )}
        {!this.state.is_loading && unreadCount > 0 && (
          <span className="label normal-label label-danger notifications-label hidden-sm hidden-xs">{unreadCount}</span>
        )}
        <span className="visible-sm visible-xs">
          <i className="fa fa-fw fa-flag" />{' '}
          {unreadCount && <span className="label normal-label label-danger notifications-label">{unreadCount}</span>}{' '}
          Notifications
        </span>
      </div>
    )
  }

  dismissNotification(id) {
    return () =>
      axios.get(`/notifications/mark_notification_as_read/${id}`).then(() => {
        this.getNotifications()
      })
  }

  renderNotificationListItem(notification, index) {
    //     return (
    //       <li className="notifications-item react-list-item" key={index}>
    //         <div className="row" data-id={notification.id} onClick={this.dismissNotification} title="Click to dismiss">
    //           <div className="col-sm-12">
    //             <strong>{notification.title}</strong> <span className="text-muted"> - {notification.date}</span>
    //             <br />
    //             {notification.description}
    //             {!!notification.url && (
    //               <span>
    //                 [<a href="{{row.url}}">go to page</a>]
    //               </span>
    //             )}
    //             {notification.title.indexOf('HMG') <= -1 &&
    //               !!notification.table &&
    //               !!notification.record_id && (
    //                 <span>
    //                   [<a href={`/user/edit_profile?show=${notification.table}&id=${notification.record_id}`}>
    //                     view record
    //                   </a>]
    //                 </span>
    //               )}
    //             {!!notification.notes &&
    //               notification.notes != 'null' && (
    //                 <div className="push-down-5 notification-notes">
    //                   <strong>Notes:</strong> {notification.notes}
    //                 </div>
    //               )}
    //             {false && <hr />}
    //           </div>
    //         </div>
    //       </li>
    //     )
    //   }
    return (
      <li className="notifications-item react-list-item" key={index}>
        <div
          className="flex__col"
          style={{ fontSize: '11px', opacity: notification.read ? '0.25' : '1' }}
          onClick={!notification.read ? this.dismissNotification(notification.id) : () => {}}
          title={!notification.read ? 'Click to dismiss' : ''}
        >
          <div className="notification__header flex__row">
            <div className="notification__icon flex--nogrow">
              <span className="fa-stack fa-lg">
                <i className="fa fa-circle fa-stack-2x" />
                <i className={`fa ${notification.read ? 'fa-envelope-o' : notification.icon} fa-stack-1x fa-inverse`} />
              </span>
            </div>
            <div className="flex__col flex__col--start-center">
              <div className="flex__row">
                <span className="flex--auto">
                  <strong>
                    {notification.read ? '(READ)' : ''} {notification.title}
                  </strong>
                </span>
              </div>
              <div>
                <span className="text-muted">{moment(notification.date).calendar()}</span>
              </div>
            </div>
          </div>
          <div className="notification__body flex__column">
            <div>{notification.description}</div>
            <div>
              {!!notification.url && (
                <span>
                  [<a href={notification.url}>go to page</a>]
                </span>
              )}
              {notification.title &&
                notification.title.indexOf('HMG') <= -1 &&
                !!notification.table &&
                !notification.hide_record && (
                  <span>
                    [<a href={`/user/profile?show=${notification.table}&id=${notification.record_id}`}>view record</a>]
                  </span>
                )}
            </div>
            <div>
              {!!notification.notes && notification.notes != 'null' && (
                <div className="push-down-5 notification-notes">
                  <strong>Notes:</strong> {notification.notes}
                </div>
              )}
              {false && <hr />}
            </div>
          </div>
        </div>
      </li>
    )
  }

  renderEmptyList() {
    return (
      <li>
        <div className="row">
          <div className="col-sm-12 text-center">
            <span className="text-muted" style={{ fontSize: '15px' }}>
              <i className="fa fa-check-circle" />
              You have no unread notifications.
            </span>
          </div>
        </div>
      </li>
    )
  }
  render() {
    return (
      <React.Fragment>
        <a href="#" className="dropdown-toggle" data-toggle="dropdown">
          {this.renderNotificationButtonContent()}
        </a>
        <ul className="dropdown-menu notifications-dropdown scroll">
          <li className="notifications-item ">
            <div>
              <a
                href="/user/all_notifications"
                className="link-button flex__row flex__row--center-center react-list-item"
              >
                <span className="text-muted" style={{ fontSize: '15px' }}>
                  <i className="fa fa-check-circle" style={{ padding: '0.5em' }} />
                  View All Notifications.
                </span>
              </a>
            </div>
          </li>
          {this.state.notifications.map(this.renderNotificationListItem)}

          {this.state.notifications.length === 0 && this.renderEmptyList()}
        </ul>
      </React.Fragment>
    )
  }
}

export default NotificationsMenu
